module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/cq04.d80058a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc/blog/cq04.jpg
// module id = Hs74
// module chunks = 0